import React from "react";
import Slider from "react-slick";

const testimonials = [
  {
    quote:
      "Colliers have worked with Metaluxe on a number of projects over the past couple of years. The visuals delivered for our developer clients, including renders, 3D video and walkthroughs, and interactive balcony views are an invaluable tool for our sales teams in bringing projects to life for potential buyers. The service delivered by Metaluxe was prompt, professional and very amenable to working with large groups of consultants including developer, architect, agent and creative agencies. We are pleased to recommend Metaluxe to clients.",
    name: "Rachel Hutson",
    title: "Director | Colliers",
    logo: "/images/colliers.webp",
  },
  {
    quote:
      "For the past three years, we have collaborated with Metaluxe on visualisations for all our major projects, including The Ritz-Carlton Gold Coast, The Main Beach Superyacht Marina, and a portfolio of other significant developments currently under commercial confidentiality. Metaluxe has consistently demonstrated meticulous attention to detail, prompt delivery, and an unwavering commitment to producing work of the highest quality. It is our pleasure to highly recommend Metaluxe for all your visualisation needs. 🙂",
    name: "Stevie Jackson",
    title: "Executive Assistant | Giannarelli Group",
    logo: "/images/ritz.webp",
    logoHeight: "h-20",
  },
  {
    quote:
      "I had the pleasure of working with Metaluxe on a recent project, and we are thrilled with the results. The 3D visuals they produced, including video renderings, detailed balcony shots, and an immersive walk-through, exceeded our expectations. Their attention to detail and creative vision brought our concepts to life in a way that was both realistic and captivating. Kaz was professional, responsive, and truly dedicated to delivering high-quality work. I highly recommend their services.",
    name: "Mia Pradella",
    title: "Director | Pradella Property",
    logo: "/images/pradella.webp",
    logoHeight: "h-10",
    logoMargin: "mt-8",
  },
  {
    quote:
      "Working with Metaluxe on our recent project was an absolute pleasure. Their 3D visuals, from stunning video renderings to intricate balcony shots and an engaging walk-through, surpassed our expectations. The level of detail and creativity they brought to the project truly brought our vision to life in a compelling and realistic way. Kaz was professional, highly responsive, and committed to delivering top-quality work. I would highly recommend Metaluxe to anyone looking for exceptional 3D visualization services.",
    name: "Simon Worthington",
    title: "Senior Sales Executive | ONE PM",
    logo: "/images/one-pm-group.webp",
    logoHeight: "h-8",
    logoMargin: "mt-10",
  },
  {
    quote:
      "Working with Metaluxe was a game-changer for our project. We needed to showcase our new development project in a way that would truly impress potential purchases, and Metaluxe’s 3D visualizations delivered exactly that. The level of realism and attention to detail was exceptional. Their team's expertise and attention to detail brought our designs to life exceeding our expectations and significantly enhancing our marketing efforts. We couldn't have asked for better results, we have now used Metaluxe for a few of our development projects and we'll definitely be using Metaluxe again for all our future projects.",
    name: "Dan Cuda",
    title: "Sunny Beach Land",
    logo: "/images/sheraton.webp",
    logoHeight: "h-16",
  },
  {
    quote:
      "We were fortunate to partner with Kaz and the Metaluxe team for our recent project, The Palms Luxury Villas. Throughout the entire process, from initial concept to final delivery, Kaz and his team exemplified professionalism, tireless dedication, and an extraordinary eye for detail. Their ability to transform our ideas into strikingly realistic and immersive concepts promises to leave a lasting impression on both viewers and buyers alike. We are already excited to be working with them again on another project. Without hesitation, we wholeheartedly recommend Metaluxe to anyone seeking to elevate their projects to new height.",
    name: "Tomas Soner",
    title: "TS Projects",
    logo: "/images/the-palms.webp",
    logoHeight: "h-24",
  },
];

const TestimonialCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    lazyLoad: 'ondemand',
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className="bg-[#29565a] py-16 px-0">
      <div className="max-w-7xl mx-auto">
        <h2 className="header text-2xl md:text-4xl text-center text-white mb-10 tracking-wide">
          WHAT OUR CUSTOMERS SAY
        </h2>
        <Slider {...settings}>
          {testimonials.map((t, i) => (
            <div key={i} className="px-4">
              <div className="bg-gradient-to-b from-white to-gray-100 rounded-xl p-6 h-full shadow-lg flex flex-col justify-between min-h-[500px]">
                <p className="text-gray-800 text-sm mb-6 leading-relaxed">
                  {t.quote}
                </p>
                <div>
                  <hr className="border-t border-gray-400 my-4" />
                  <p className="font-semibold text-gray-800">{t.name}</p>
                  <p className="text-sm text-gray-600">{t.title}</p>
                </div>
              </div>
              <img
                src={t.logo}
                alt="Logo"
                loading="lazy"
                className={`${t.logoHeight ? t.logoHeight : "h-16"}
                ${t.logoMargin ? t.logoMargin : "mt-4"}
                 m-auto`}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
